import { NgModule }              from '@angular/core';
import { RouterModule, Routes }  from '@angular/router';


import { HomeComponent } from './pages/home.component';
import { SelectComponent } from './pages/select/select.component';
import { AppComponent } from './app.component';
import { AboutUsComponent } from './pages/shared/about-us/about-us.component';
import { AuthGuard } from './guards/auth.guard';


const appRoutes: Routes = [

    {
      path: 'select',
      component: SelectComponent,
      canActivate: [AuthGuard]
    },
    {
      path: 'about-us',
      component: AboutUsComponent
    },
    {
      path: 'article',
      loadChildren: () => import('../app/pages/content-articles/content-articles.module').then(m => m.ContentArticlesModule)
    },
    {
      path: 'home/:redirect',
      component: HomeComponent
    },
    {
      path: '',
      redirectTo: 'home/',
      pathMatch: 'full'
    },
   {
      path: '**',
      redirectTo: 'home/',
      pathMatch: 'full'
    }
];


@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes // <-- debugging purposes only
, {})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
